import { ColorIcon, HStack, colors } from "goi_common";

interface Props {
  score: number;
}

const RATING_LIST = [1, 2, 3, 4, 5];

const ReviewStarList = ({ score }: Props) => {
  return (
    <HStack gap="4px">
      {RATING_LIST.map((rating) => (
        <ColorIcon
          key={rating}
          name="rating_star"
          color={rating <= score ? colors.reviewYellow : colors.gray100}
          size={12}
        />
      ))}
    </HStack>
  );
};

export default ReviewStarList;
